import { useEffect, useState, useRef } from "react";
import { Image } from 'antd-mobile';
import { isMobile, jumpPage } from '@/utils/common'
import './Navbar.less'
// 组件
import UserDrawer from '@/component/Drawer/UserDrawer/user-drawer';
// 图片
import logo from "@/image/common/logo.svg";
import menuSvg from "@/image/common/menu.svg";
// import { DialogShowHandler } from 'antd-mobile/es/components/dialog'
// import LoginDialog from '@/component/Dialog/LoginDialog/login-dialog'
// import { postLogin } from '@/api/user';
// import { postActivityDetail } from '@/api/invite'
// import { store } from '@/store'
// import { setUserInfo } from "@/store/userInfo/action"

export const Navbar = () => {
  // const handler = useRef<DialogShowHandler>()
  // const childRef:any = useRef(null)
  const [menuImg] = useState(menuSvg)
  // const [chargeBtnClass] = useState('recharge')
  const [activeNav, setActiveNav] = useState<string>(window.location.pathname)
  const [token, setToken] = useState(localStorage.getItem('token'))
  const blackList = useState<Array<string>>([
    '/explanation-coach-level/'
  ])

  useEffect(() => {
    setToken(localStorage.getItem('token'))
  }, [token])

  useEffect(() => {
    const result = blackList.find(e => window.location.pathname.includes(e.toString()))

    if (result) {
      const navBar = document.getElementById('navBarId') as any
      navBar.style.display = 'none'
    }
  }, [blackList])

  // const loginDialog = () => {
  //   let disabled = false
  //   handler.current = Dialog.show({
  //     content: (
  //       <LoginDialog ref={childRef} />
  //     ),
  //     // closeOnAction: true,
  //     actions: [
  //       [
  //         {
  //           key: 'cancel',
  //           text: '取消',
  //           onClick: () => {
  //             handler.current?.close()
  //           },
  //         },
  //         {
  //           key: 'confirm',
  //           text: '确定',
  //           bold: true,
  //           disabled,
  //           onClick: () => {
  //             const { mobile, code } = childRef.current.state
  //             const values = {
  //               mobile,
  //               code,
  //             }
  //             if (childRef.current.verifyContent() && !disabled) {
  //               disabled = true
  //               postLogin(values).then(async (e:any) => {
  //                 const { token } = e;
  //                 if(token && token !== 'undefined') {
  //                   localStorage.setItem("token", token);
  //                   localStorage.setItem("userInfo", JSON.stringify(e));
  //                   let action = setUserInfo(e)

  //                   postActivityDetail({
  //                     activity_code: 'YQ001'
  //                   }).then(e2 => {
  //                     const obj = { ...e, invite_code: e2 ? e2.pretty_number : '' }
  //                     localStorage.setItem("userInfo", JSON.stringify(obj));
  //                     action = setUserInfo(obj)
  //                   }).finally(() => {
  //                     store.dispatch(action)
  //                     handler.current?.close()
  //                   })
                    
  //                   setToken(token)
  //                   Toast.show({
  //                     icon: 'success',
  //                     content: '登录成功！',
  //                   })

  //                   const searchParams = new URLSearchParams(window.location.search);
  //                   const page = searchParams.get('router')
  //                   if (page) {
  //                     setTimeout(() => {
  //                       window.location.href = page
  //                     }, 1000)
  //                   }
  //                 }
  //               })
  //               .finally(() => {
  //                 disabled = false
  //               })
  //             }
  //           },
  //         },
  //       ],
  //     ],
  //   })
  // }

  const drawerRef:any = useRef(null);
  const openMenu = () => {
    drawerRef.current.setState({
      pageClass: 'user-drawer-page'
    })
  }

  const handleNav = (path:string) => {
    setActiveNav(path)
    jumpPage(path)
  }

  return (
    <>
      <header id="navBarId" className="nav-bar">
        <Image src={logo} fit='contain' />

        <ul>
          {
            isMobile() ?
            <li className="menu" onClick={openMenu}>
              <Image src={menuImg} className="svg" fit='contain' />
            </li> :
            <>
              <li className={activeNav === '/' ? 'active' : ''} onClick={() => handleNav('/')}>首页</li>
              <li className={activeNav === '/about-us' ? 'active' : ''} onClick={() => handleNav('/about-us')}>关于我们</li>
              <li className={activeNav === '/contact-us' ? 'active' : ''} onClick={() => handleNav('/contact-us')}>联系我们</li>
            </>
          }
          {/* {
            token ? <>
              { ['/', 'home'].includes(window.location.pathname) ? <li className={chargeBtnClass}><a href='/recharge'>充值</a></li> : '' }
              <li onClick={openMenu}>
                <Image src={menuImg} className="svg" fit='contain' />
              </li> 
            </> :
            <li className={chargeBtnClass} onClick={loginDialog}>登录</li>
          } */}
        </ul>
      </header>

      <UserDrawer ref={drawerRef} parentFunc={() => setToken('')} />
    </>
  )
}